module.exports = __webpack_public_path__ + "media/src/images/mails/iversity-logo-3c8497e785a7d347b64539ea558ad863.png";